import React, { createContext, Context } from 'react';

export interface HeaderContextInterface {
  leftButton?: React.ReactNode;
  setLeftButton: (component?: React.ReactNode) => void;
  rightButton?: React.ReactNode;
  setRightButton: (component?: React.ReactNode) => void;
  handleSearchClick?: () => void;
}

/**
 * Information about the header and which buttons to show.
 * This allows components to change what is rendered in the header
 * at any time depending on certain conditions.
 */
export const HeaderContext: Context<HeaderContextInterface> = createContext({
  setLeftButton: () => {},
  setRightButton: () => {},
});
